// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zz-0";
export var tagInputDisabled = "_zz-1";